$(function(){
    /**
	 * 生年月日
	 */
	// 変更時
	$('.form__birth.birthday_year, .form__birth.birthday_month, .form__birth.birthday_day').on('change', function(){
		if ($('.form__birth.birthday_year').val() == '' || 
			$('.form__birth.birthday_month').val() == '' ||
			$('.form__birth.birthday_day').val() == ''){
				$('#plan3').prop("disabled", true);
				return false;
		}
		// 年齢計算
		var dBirthday = new Date($('.form__birth.birthday_year').val(), $('.form__birth.birthday_month').val(), $('.form__birth.birthday_day').val());
		// 本日
		var dToday = new Date();
		// 今年の誕生日
		var dThisYearBirthday = new Date(dToday.getFullYear(), dBirthday.getMonth()-1, dBirthday.getDate());
		// 今年 - 誕生年
		var iAge = dToday.getFullYear() - dBirthday.getFullYear();
		// 今年の誕生日を迎えていなければage-1
		var iAge = (dToday < dThisYearBirthday) ? iAge - 1 : iAge;
		// 22歳以下ならユースプラン選択可
		$('#plan3').prop("disabled", !(iAge <= 22));
		
		// 22歳よりも上＋ユースコースが選ばれていた場合は一般に変更
		if (iAge > 22 && $('#plan3').prop('checked')){
			$('#plan1').prop('checked', true);
		}
	});
});